/* eslint-disable import/no-anonymous-default-export */
import { Alert } from "../components/Alert.components";

import {
  getDepartments,
  getUserTypes,
  getCallCodes
} from "../services/auxillary";


export default {
  namespace: "auxillary",

  state: {
    departmentsList: [],
    callCodesList: [],
    userTypesList: []
  },

  subscriptions: {
    setup({ dispatch, history }) {
      // eslint-disable-line
    },
  },

  effects: {
    *fetchAllDepartments({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getDepartments, payload);
      if (success) {
        const list = raw?.departments;
        yield put({
          type: "save",
          payload: { departmentsList: list },
        });
      } else {
        Alert.error(message);
      }
    },
    *fetchCallCodes({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getCallCodes, payload);
      if (success) {
        const list = raw?.countries;
        yield put({
          type: "save",
          payload: { callCodesList: list },
        });
      } else {
        Alert.error(message);
      }
    },
    *fetchAllUserTypes({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getUserTypes, payload);
      if (success) {
        const list = raw?.userTypes;
        yield put({
          type: "save",
          payload: { userTypesList: list },
        });
      } else {
        Alert.error(message);
      }
    },
  },
  

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
